import React from 'react';
import PropTypes from 'prop-types';
import { LICENSING_STEP, PLAN_STATUS } from '../../constants';
import DownloadVersionPicker from '../DownloadVersionPicker';
import ElementTransition from '../ElementTransition';
import LicenseInput from '../LicenseInput';
import NoMoreLicenses from '../NoMoreLicenses';
import Payment from '../Payment';
import Plan from '../Plans';

class Licensing extends React.PureComponent {
  static propTypes = {
    step: PropTypes.string,
    onCancel: PropTypes.func,
    onLicenseClip: PropTypes.func,
    licensingError: PropTypes.string,
    onPickVersion: PropTypes.func,
    desiredVersion: PropTypes.string,
    downloadables: PropTypes.object,
    downloadablesFetching: PropTypes.bool,
    onDownloadClip: PropTypes.func,
    downloadClipError: PropTypes.string,
    alreadyLicensed: PropTypes.bool,
    pastDue: PropTypes.bool,
    chosenPlan: PropTypes.object,
    couponCode: PropTypes.string,
    couponError: PropTypes.string,
    activePlan: PropTypes.object,
    planSummary: PropTypes.object,
    hasSubscription: PropTypes.bool,
    paymentError: PropTypes.string,
    onGoToPlan: PropTypes.func,
    onChangePlan: PropTypes.func,
    onChangeCoupon: PropTypes.func,
    onConfirmPlan: PropTypes.func,
    onUpdateSubscription: PropTypes.func,
  };
  static defaultProps = {};

  render() {
    const {
      step,
      onCancel,
      onLicenseClip,
      licensingError,
      onPickVersion,
      desiredVersion,
      downloadables,
      downloadablesFetching,
      onDownloadClip,
      downloadClipError,
      alreadyLicensed,
      pastDue,
      chosenPlan,
      couponCode,
      couponError,
      activePlan,
      planSummary,
      hasSubscription,
      paymentError,
      onGoToPlan,
      onChangePlan,
      onChangeCoupon,
      onConfirmPlan,
      onUpdateSubscription,
      ...otherProps
    } = this.props;

    const downloadVersionPickerProps = {
      alreadyLicensed: alreadyLicensed,
      pastDue: pastDue,
      selectedVersion: desiredVersion,
      onPickVersion: onPickVersion,
      downloadables: downloadables,
      downloadablesFetching: downloadablesFetching,
      onDownloadClip: onDownloadClip,
    };
    const licenseInputProps = {
      onSubmit: onLicenseClip,
      onCancel: onCancel,
      licensingError: licensingError,
    };
    const noMoreLicensesProps = {
      onGoToPlan: onGoToPlan,
      onCancel: onCancel,
    };
    const planProps = {
      chosenPlan: chosenPlan,
      activePlan: activePlan,
      onChangePlan: onChangePlan,
      onConfirmPlan: onConfirmPlan,
    };
    const paymentProps = {
      allowCoupon: !hasSubscription,
      paymentOnFile: hasSubscription,
      chosenPlan: chosenPlan,
      couponCode: couponCode,
      couponError: couponError,
      paymentError: paymentError,
      planSummary: planSummary,
      onGoToPlan: onGoToPlan,
      onChangeCoupon: onChangeCoupon,
      onCreateSubscription: onUpdateSubscription,
    };

    let activeItem;
    switch (step) {
      case LICENSING_STEP.LICENSE_DESCRIPTION:
        activeItem = {
          id: 'description',
          element: <LicenseInput {...licenseInputProps} />,
        };
        break;
      case LICENSING_STEP.OUT_OF_LICENSES:
        activeItem = {
          id: 'noMore',
          element: <NoMoreLicenses {...noMoreLicensesProps} />,
        };
        break;
      case LICENSING_STEP.PICK_VERSION:
        activeItem = {
          id: 'pickVersion',
          element: <DownloadVersionPicker {...downloadVersionPickerProps} />,
        };
        break;
      case LICENSING_STEP.PLAN:
        activeItem = {
          id: 'plan',
          element: <Plan {...planProps} />,
        };
        break;
      case LICENSING_STEP.PAY:
        activeItem = {
          id: 'payment',
          element: <Payment {...paymentProps} />,
        };
        break;
      default:
        activeItem = { id: 'nothing', element: null };
        break;
    }

    return <ElementTransition {...activeItem} />;
  }
}

export default Licensing;



// WEBPACK FOOTER //
// ./src/components/Licensing/Licensing.js